import { Scores } from '@/modules/league/new-components/matches-components/MatchesComponent/MatchCard/MatchCard';
import { CompletedMatch, MatchesPlayers } from '@/modules/league/new-components/types';

// initialized Scores Array for Enter Score Modal
export const initializeScoresArray = (player: MatchesPlayers) => [
  {
    team1Score: player?.Team_1_Game1Score || 0,
    team2Score: player?.Team_2_Game1Score || 0,
  },
  {
    team1Score: player?.Team_1_Game2Score || 0,
    team2Score: player?.Team_2_Game2Score || 0,
  },
  {
    team1Score: player?.Team_1_Game3Score || 0,
    team2Score: player?.Team_2_Game3Score || 0,
  },
  {
    team1Score: player?.Team_1_Game4Score || 0,
    team2Score: player?.Team_2_Game4Score || 0,
  },
  {
    team1Score: player?.Team_1_Game5Score || 0,
    team2Score: player?.Team_2_Game5Score || 0,
  },
];

// get Score for Score Section on Matches card
export const getScore = (player: MatchesPlayers, teamOrder: number, gameNumber: number) => {
  return player[('Team_' + teamOrder + '_Game' + gameNumber + 'Score') as keyof Scores];
};
// get Score for Score Section on Matches card
export const getScorePl = (scores: Scores, teamOrder: number, gameNumber: number) => {
  return scores[('Team_' + teamOrder + '_Game' + gameNumber + 'Score') as keyof Scores];
};
export const defaultScoresArray = (player: MatchesPlayers): Scores => {
  return {
    ScoreID: player.ScoreID || '', // Ensure ScoreID is set
    Team_1_Game1Score: player.Team_1_Game1Score || 0,
    Team_1_Game2Score: player.Team_1_Game2Score || 0,
    Team_1_Game3Score: player.Team_1_Game3Score || 0,
    Team_1_Game4Score: player.Team_1_Game4Score || 0,
    Team_1_Game5Score: player.Team_1_Game5Score || 0,
    Team_2_Game1Score: player.Team_2_Game1Score || 0,
    Team_2_Game2Score: player.Team_2_Game2Score || 0,
    Team_2_Game3Score: player.Team_2_Game3Score || 0,
    Team_2_Game4Score: player.Team_2_Game4Score || 0,
    Team_2_Game5Score: player.Team_2_Game5Score || 0,
  };
};
export const initializeScoresArrayForEdit = (player: CompletedMatch) => [
  {
    team1Score: player?.Team_1_Game1Score || 0,
    team2Score: player?.Team_2_Game1Score || 0,
  },
  {
    team1Score: player?.Team_1_Game2Score || 0,
    team2Score: player?.Team_2_Game2Score || 0,
  },
  {
    team1Score: player?.Team_1_Game3Score || 0,
    team2Score: player?.Team_2_Game3Score || 0,
  },
  {
    team1Score: player?.Team_1_Game4Score || 0,
    team2Score: player?.Team_2_Game4Score || 0,
  },
  {
    team1Score: player?.Team_1_Game5Score || 0,
    team2Score: player?.Team_2_Game5Score || 0,
  },
];
